<div *ngIf="tareasCambios.length > 0; else noAutorizado">
  <div class="evidencia-config-classroom">
    <form *ngIf="notSaving$ | async; else saving" [formGroup]="classroomSelectForm">
      <mat-form-field>
        <mat-label>Tareas de Classroom disponibles</mat-label>
        <mat-select formControlName="classroomSelect" [disabled]="!editable">
          <mat-option *ngFor="let work of tareasCambios" [value]="work.id">
            {{work.title}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
    <ng-template #saving>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <a matTooltip="Ir a la tarea" *ngIf="evento.courseWork"
      [href]="evento.courseWork ? evento.courseWork.alternateLink : ''" target="_blank" class="misc-icons">
        <mat-icon>launch</mat-icon>
    </a>
    <button matTooltip="Desenlazar" *ngIf="evento.courseWork" (click)="desEnlazar()" mat-icon-button>
      <mat-icon>link_off</mat-icon>
    </button>
  </div>
</div>
<ng-template #noAutorizado>
  <div class="evidencia-config-classroom">
    <mat-select
      matTooltip="Usted no puede hacer acciones sobre este Classroom, por favor comuniquese con el usuario que enlazo la clase."
      matTooltipPosition="before"
      disabled="true" value="0">
      <mat-option value="0">
        Classroom de otro usuario
      </mat-option>
    </mat-select>
    <button disabled="true" mat-icon-button class="misc-icons">
      <mat-icon>launch</mat-icon>
    </button>
    <button disabled="true" mat-icon-button class="misc-icons">
      <mat-icon>link_off</mat-icon>
    </button>
  </div>
</ng-template>
